var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSpecial = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_special",
    d: "M513.389,358.849a3.848,3.848,0,0,1,0-5.444l0,0a3.95,3.95,0,0,1,5.449,0,3.851,3.851,0,1,1-5.345,5.545c-.035-.033-.07-.067-.1-.1Zm13-6.534a6.417,6.417,0,1,1,6.421-6.417h0A6.427,6.427,0,0,1,526.389,352.316Zm10.321-16.74a14.978,14.978,0,0,0-24.858,15.217,6.646,6.646,0,0,1,2.409-1.378,12.3,12.3,0,1,1,8.612,8.576,6.756,6.756,0,0,1-1.431,2.42,14.983,14.983,0,0,0,15.267-24.837Z",
    transform: "translate(-511.107 -331.161)",
    fill: "#00a1af"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSpecial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_special.6e6ad802b457c6196c8ee6561a298a0a.svg";